import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import CrossIcon from "../../../assets/icons/crossIcon";

interface ResolvedModalProps {
  resolvedDrawer: boolean;
  setResolvedDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  handleTicketResolvedAction?: () => void;
}
const ResolvedModal: React.FC<ResolvedModalProps> = ({
  resolvedDrawer,
  setResolvedDrawer,
  handleTicketResolvedAction,
}) => {
  return (
    <Modal
      className="hidden md:block"
      open={resolvedDrawer}
      onClose={() => setResolvedDrawer(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "35%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box className="flex flex-col gap-4 ">
          <Typography className="!pt-4 !px-3 !text-xl !font-medium !flex !justify-center">
            Are you sure you want to resolve the ticket?
          </Typography>

          <Button
            sx={{
              textTransform: "none",
              backgroundColor: "rgba(0, 112, 242, 1)",
              color: "#fff",
              padding: "0.5rem 0 0.5rem 0",
            }}
            onClick={handleTicketResolvedAction}
          >
            Yes
          </Button>
          <Button
            sx={{
              textTransform: "none",
              border: "1px solid rgba(0, 0, 0, 0.2)",
              color: "rgba(40, 40, 40, 1)",
              padding: "0.5rem 0 0.5rem 0",
              marginBottom: "1rem",
            }}
            onClick={() => setResolvedDrawer(false)}
          >
            No
          </Button>
        </Box>
        <Typography
          className="absolute top-0 right-0 p-1 cursor-pointer"
          onClick={() => setResolvedDrawer(false)}
        >
          <CrossIcon />
        </Typography>
      </Box>
    </Modal>
  );
};

export default ResolvedModal;
